export enum ActionTypes {
  INIT_DATA = 'INIT_DATA',
  REMOVE_REQUEST = 'REMOVE_REQUEST'
}

export enum MutationTypes {
  SET_REQUEST_LIST = 'SET_REQUEST_LIST',
  REMOVE_REQUEST = 'REMOVE_REQUEST',
  SET_NOTIFICATION = 'SET_NOTIFICATION',
  UPDATE_REQUEST_INPUT_SIZE_LIST = 'UPDATE_REQUEST_INPUT_SIZE_LIST',
  UPDATE_REQUEST_ACCEPTING_INPUT = 'UPDATE_REQUEST_ACCEPTING_INPUT',
}
